// extracted by mini-css-extract-plugin
export default {"reviewContainerOuter":"cKQyybJcI","review":"cR770DZZi","author":"cAu3hQKCx","quote":"cF76LwvzU","slickSlider":"cLmD8RJeO"};